import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { notification } from 'antd'

import cancelRunout from 'core/application/csiDashboard/csiSearch/cancelRunout'
import { BenefitDetails } from 'core/application/csiDashboard/csiSearch/getBenefitDetails'
import triggerRunout from 'core/application/csiDashboard/csiSearch/triggerEarlyRunout'

import { commandRequest } from '../../../../../../common/RequestUtils'
import Button from '../../../../../../common/components/general/Button'
import TriggerEarlyRunout from '../../../common/programDetails/TriggerEarlyRunout'
import CancelRunout from '../CancelRunout'

interface BenefitDetailsProps {
  benefitDetails: BenefitDetails
  refreshBenefitDetails: () => Promise<void>
}

const EarlyRunoutDetails: React.FC<BenefitDetailsProps> = (props) => {
  const { t: translate } = useTranslation()
  const [earlyRunoutDate, setEarlyRunoutDate] = useState<string>('')
  const [earlyRunoutDays, setEarlyRunoutDays] = useState<number>(90)
  const [sendEmail, setSendEmail] = useState<boolean>(true)
  const [showTriggerEarlyRunoutDate, setShowTriggerEarlyRunoutDate] = useState<boolean>(false)
  const [showCancelRunout, setShowCancelRunout] = useState<boolean>(false)
  const [loadingSubmitEarlyRunout, setLoadingSubmitEarlyRunout] = useState<boolean>(false)
  const [loadingSubmitCancelRunout, setLoadingSubmitCancelRunout] = useState<boolean>(false)

  const submitEarlyRunout = async () => {
    setLoadingSubmitEarlyRunout(true)
    const result = await commandRequest(() =>
      triggerRunout(props.benefitDetails.id, earlyRunoutDate, earlyRunoutDays, sendEmail),
    )
    if (!result.errors) {
      notification.open({
        message: translate('csi-dashboard.program-details.trigger-early-runout.success'),
        type: 'success',
      })
      setShowTriggerEarlyRunoutDate(false)
      await props.refreshBenefitDetails()
    } else {
      notification.open({
        message: result.errors[0],
        type: 'error',
      })
    }
    setLoadingSubmitEarlyRunout(false)
  }

  const submitCancelRunout = async () => {
    setLoadingSubmitCancelRunout(true)
    const result = await commandRequest(() => cancelRunout(props.benefitDetails.id))
    if (!result.errors) {
      notification.open({
        message: translate('csi-dashboard.program-details.cancel-runout.success'),
        type: 'success',
      })
      setLoadingSubmitCancelRunout(false)
      await props.refreshBenefitDetails()
    } else {
      notification.open({
        message: result.errors[0],
        type: 'error',
      })
    }
    setLoadingSubmitCancelRunout(false)
  }

  return (
    <div>
      <div>
        <Button
          type="default"
          onClick={() => {
            setShowTriggerEarlyRunoutDate(true)
          }}
          disabled={!props.benefitDetails.allowToTriggeringEarlyRunout}
        >
          {translate('csi-dashboard.program-details.trigger-early-runout.title')}
        </Button>
        <Button
          type="default"
          onClick={() => {
            setShowCancelRunout(true)
          }}
          disabled={!props.benefitDetails.allowCancelRunout}
          className={props.benefitDetails.allowCancelRunout ? 'ml-16' : 'd-none'}
        >
          {translate('csi-dashboard.program-details.cancel-runout.title')}
        </Button>
        <TriggerEarlyRunout
          translate={translate}
          showTriggerEarlyRunoutDate={showTriggerEarlyRunoutDate}
          setShowTriggerEarlyRunoutDate={setShowTriggerEarlyRunoutDate}
          earlyRunoutDate={earlyRunoutDate}
          setEarlyRunoutDate={setEarlyRunoutDate}
          submitEarlyRunout={submitEarlyRunout}
          earlyRunoutDays={earlyRunoutDays}
          setEarlyRunoutDays={setEarlyRunoutDays}
          setSendEmail={setSendEmail}
          loading={loadingSubmitEarlyRunout}
          benefitDetails={props.benefitDetails}
        />
        <CancelRunout
          translate={translate}
          showCancelRunout={showCancelRunout}
          setShowCancelRunout={setShowCancelRunout}
          submitCancelRunout={submitCancelRunout}
          loading={loadingSubmitCancelRunout}
        ></CancelRunout>
      </div>
    </div>
  )
}

export default EarlyRunoutDetails
